import gql from 'graphql-tag';
export const MockExamHistogramDataRangeFragment = gql`
  fragment MockExamHistogramDataRangeFragment on MockExamHistogramDataRange {
    min
    max
  }
`;

export const MockExamHistogramDataFragment = gql`
  fragment MockExamHistogramDataFragment on MockExamHistogramData {
    count
    percent
    range {
      ...MockExamHistogramDataRangeFragment
    }
  }
  ${MockExamHistogramDataRangeFragment}
`;

export const MockExamResultFragment = gql`
  fragment MockExamResultFragment on MockExamResult {
    id
    examId
    fullScore
    maximumScore
    minimumScore
    averageScore
    sdScore
    examAttendee
    histogram {
      ...MockExamHistogramDataFragment
    }
  }
  ${MockExamHistogramDataFragment}
`;

export const MyMockExamResultFragment = gql`
  fragment MyMockExamResultFragment on MyMockExamResult {
    id
    examId
    examCardId
    score
    rank
    percentile
  }
`;

export const MyMockExamResultFragmentV2 = gql`
  fragment MyMockExamResultFragmentV2 on MockExamStudentStat {
    # id
    examId
    examCardId
    score
    rank
    percentile
  }
`;
